export default __webpack_public_path__ + "static/media/nest.9cfa484a.png";